import React, { Component } from 'react';
import { getCompanyName, getUsersByCompany, deleteUser } from '../../Authentication';
import { AccessibleDataTable } from '../../AccessibleDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faCheck, faTimes, faEye } from '@fortawesome/free-solid-svg-icons';
import './usermanagement.css';
import { showConfirmation } from '../../ConfirmationModal';

export class UserManagement extends Component {
    static displayName = UserManagement.name;

    constructor(props) {
        super(props);
        this.state = {
            companyName: null,
            users: []
        }
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let companyName = this.state.companyName;
        let users = this.state.users;

        let tableRows = [];
        if (users.length > 0) {
            let usersArray = JSON.parse(users);
            for (var i = 0; i < usersArray.length; i++) {
                let user = usersArray[i];
                let row = {
                    editUser: <a href={'UpdateUser/' + user.id} className='update-btn' title='Edit' aria-label="Edit user"><FontAwesomeIcon icon={faEdit} aria-hidden="true" /></a>,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    deleteUser: <button type="button" className='delete-btn' onClick={this.deleteUser.bind(this, user.id, user.email)} title='Delete' aria-label="Delete"><FontAwesomeIcon icon={faTrashAlt} aria-hidden="true" /></button>
                };
                tableRows.push(row);
            }
        }

        let table = {
            columns: [
                { label: '', field: 'editUser' },
                { label: 'First Name', field: 'firstName', sort: 'asc' },
                { label: 'Last Name', field: 'lastName', sort: 'asc' },
                { label: 'Email', field: 'email', sort: 'asc' },
                { label: '', field: 'deleteUser' }
            ],
            rows: tableRows
        };

        return (
            <div className='user-management-container'>
                <div className='page-title'>
                    <h1>{companyName} User Management</h1>
                </div>

                <div className='table-container'>
                    <a href='/CreateUser' title='Create a new user'><button className='form-management-button'>Create User</button></a>

                    <AccessibleDataTable caption="Users" entries={100} data={table} />
                </div>
            </div>
        );
    }

    async getComponentData() {
        const companyName = await getCompanyName();
        const users = await getUsersByCompany(companyName);

        this.setState({
            companyName: companyName,
            users: users
        });
    }

    async deleteUser(userId, userEmail) {
        let confirm = await showConfirmation("Are you sure you want to delete " + userEmail + "?");
        if (confirm) {
            const deleteUserResponse = await deleteUser(userId, this.state.companyName);
            this.getComponentData();
        }
    }
}

export default UserManagement;